import { Typography } from '@workspace/ui/components/Typography';
import { Cart24, Heart24, Search24, User24 } from '@workspace/ui/icons';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { SearchBar } from '~/components/HeaderV3/components/SearchBar';
import { HeaderFavs } from '~/components/MobileHeaderCD/components/HeaderFavs';
import { ModalType } from '~/components/Modal/interface';
import { useModal } from '~/hooks/useModal';
import { userStore } from '~/stores';
import { favoritesStore } from '~/stores/FavoritesStore/FavoritesStore';

import { HeaderDubaiExpressCartButton } from './HeaderDubaiExpressCartButton';

const iconClassName = 'text-navigation-icon-primary';

/**
 * User actions for the DubaiExpress header (desktop): search, favorites,
 * profile and cart. The header is always solid (white), so icons use the
 * primary navigation color directly.
 */
export const HeaderDubaiExpressNavigation = observer(() => {
  const { openModal } = useModal();

  const favsCount = favoritesStore.favorites.length;

  const handleAuth = (e: React.MouseEvent) => {
    if (userStore.isAuthorized) {
      return;
    }
    e.preventDefault();
    openModal(ModalType.Auth, 'header', {
      redirect: '/cabinet',
    });
  };

  return (
    <>
      <SearchBar
        trigger={
          <div className={iconClassName}>
            <Search24 />
          </div>
        }
        fixedWidth={600}
      />
      <HeaderFavs
        enableCaption={false}
        enableLabel={false}
        icon={
          <>
            <Heart24 />
            {favsCount > 0 && (
              <Typography.Text200Semibold
                as="span"
                className="absolute -top-[10px] -right-[14px] size-6 rounded-full bg-action-brand p-1 text-center text-text-in-button"
              >
                {favsCount}
              </Typography.Text200Semibold>
            )}
          </>
        }
        className={`max-h-max ${iconClassName}`}
        dropdownClassName="max-w-[480px] right-[128px] left-auto! transform-[translate(0)]! bg-bg-content!"
      />
      <Link
        to="/cabinet"
        onClick={handleAuth}
        data-link="header-cabinet"
        className={iconClassName}
      >
        <User24 />
      </Link>
      <HeaderDubaiExpressCartButton>
        <Cart24 />
      </HeaderDubaiExpressCartButton>
    </>
  );
});
HeaderDubaiExpressNavigation.displayName = 'HeaderDubaiExpressNavigation';
